<template>
  <v-container class="my-1">
    <v-card>
      <v-card-title class="page-head">
        <div class="ph-left">
          <div class="ph-icon"><v-icon color="#00838f">mdi-account-arrow-right</v-icon></div>
          <div>
            <div class="ph-title">Assign Child to Care Giver</div>
            <div class="ph-sub">Manage child-care giver assignments</div>
          </div>
        </div>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search..."
          outlined
          dense
          hide-details
          class="ph-search"
        />
        <v-btn class="ph-btn" @click="formNuevo()">
          <v-icon left small>mdi-plus</v-icon>
          New Assignment
        </v-btn>
      </v-card-title>

      <v-data-table
        class="elevation-4 assign-table"
        :search="search"
        :headers="headers"
        :items="assignments"
        item-value="idga"
        fixed-header
        :height="500"
        :mobile-breakpoint="600"
      >
        <template v-slot:item.index="{ index }">
          <span class="cell-muted">{{ index + 1 }}</span>
        </template>

        <template v-slot:item.childname="{ item }">
          <span class="cell-name">{{ item.childname }}</span>
        </template>

        <!-- Wrap potentially long mother names -->
        <template v-slot:item.mothername="{ item }">
          <div class="wrap">{{ item.mothername }}</div>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            small
            :color="item.status === 'Permanant' ? '#e8f5e9' : '#fff8e1'"
            :text-color="item.status === 'Permanant' ? '#2e7d32' : '#f57f17'"
          >
            {{ item.status }}
          </v-chip>
        </template>

        <!-- Description: respect saved line breaks -->
        <template v-slot:item.description="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pre-line break-anywhere">{{ item.description }}</span>
            </template>
            <span class="pre-line">{{ item.description }}</span>
          </v-tooltip>
        </template>

        <!-- Files: download buttons for ministry and court files -->
        <template v-slot:item.files="{ item }">
          <div class="d-flex" style="gap: 8px; flex-wrap: wrap;">
            <v-btn
              v-if="item.ministryfile"
              small
              outlined
              color="primary"
              :href="fileUrl(item.ministryfile)"
              target="_blank"
              :download="basename(item.ministryfile)"
            >
              <v-icon left small>mdi-file-download</v-icon>
              Ministry
            </v-btn>
            <v-btn
              v-if="item.courtfile"
              small
              outlined
              color="primary"
              :href="fileUrl(item.courtfile)"
              target="_blank"
              :download="basename(item.courtfile)"
            >
              <v-icon left small>mdi-file-download</v-icon>
              Court
            </v-btn>
            <span v-if="!item.ministryfile && !item.courtfile" class="grey--text">No files</span>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small color="#2e7d32" v-bind="attrs" v-on="on" @click="formEditar(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit assignment</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small color="#c62828" v-bind="attrs" v-on="on" @click="borrar(item.id)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete assignment</span>
          </v-tooltip>
        </template>
         <template v-slot:item.more="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#1565c0" v-bind="attrs" v-on="on" @click="show(item.id)">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>View details</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="empty-state">
              <v-icon size="44" color="#b0bec5">mdi-account-arrow-right-outline</v-icon>
              <div class="empty-text">No assignments found</div>
            </div>
          </template>
      </v-data-table>
    </v-card>
    <!-- view more data -->
    <v-dialog v-model="diag" scrollable max-width="520px" >
        <v-card v-for="more in moreinfo" :key="more.id" id="printMe">
          <div class="dlg-head">
            <div class="dlg-head-icon"><v-icon color="#fff">mdi-account-arrow-right</v-icon></div>
            <div>
              <div class="dlg-title">Assignment Details</div>
              <div class="dlg-sub">{{ more.childname }} &rarr; {{ more.mothername }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="diag = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <div class="d-flex justify-center pt-5 pb-2" style="gap: 48px;">
            <div class="text-center">
              <v-avatar size="80" class="avatar-ring lg">
                <v-img v-if="more.motherimage" :src="uploadBaseUrl + more.motherimage" />
                <v-icon v-else size="36" color="#90a4ae">mdi-account-heart</v-icon>
              </v-avatar>
              <div class="cell-muted mt-1">Care Giver</div>
            </div>
            <div class="text-center">
              <v-avatar size="80" class="avatar-ring lg">
                <v-img v-if="more.childimage" :src="uploadBaseUrl + more.childimage" />
                <v-icon v-else size="36" color="#90a4ae">mdi-human-child</v-icon>
              </v-avatar>
              <div class="cell-muted mt-1">Child</div>
            </div>
          </div>


          <v-card-text style="height: 300px;">
            <v-simple-table>
              <tbody>
                <tr><th>Care Giver</th><td>{{ more.mothername }}</td></tr>
                <tr><th> Sex</th><td>{{ more.msex }}</td></tr>
                <tr><th>Child Name</th><td>{{ more.childname }}</td></tr>
                <tr><th>Child Sex</th><td>{{ more.sex }}</td></tr>
                <tr><th>Nabadoon Name</th><td>{{ more.name }}</td></tr>
                <tr><th>Nabadoon Phone</th><td>{{ more.phone }}</td></tr>
                <tr><th>Child Date of Birth</th><td>{{ more.dateofbirth }}</td></tr>
                <tr><th>child age</th><td>{{ more.age }}</td></tr>
                <tr><th>Street</th><td>{{ more.healthstatus }}</td></tr>
                <tr><th>Contact</th><td>{{ more.contact }}</td></tr>
                <tr><th>Economics</th><td>{{ more.mothereconomics }}</td></tr>
                <tr><th>Place of Birth</th><td>{{ more.placeofbirth }}</td></tr>
                <tr><th>Status</th><td>{{ more.status }}</td></tr>
                <tr>
                  <th>Ministry File</th>
                  <td>
                    <a v-if="more.ministryfile" :href="fileUrl(more.ministryfile)" target="_blank" :download="basename(more.ministryfile)">Download</a>
                    <span v-else>—</span>
                  </td>
                </tr>
                <tr>
                  <th>Court File</th>
                  <td>
                    <a v-if="more.courtfile" :href="fileUrl(more.courtfile)" target="_blank" :download="basename(more.courtfile)">Download</a>
                    <span v-else>—</span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        
        </v-card>
      </v-dialog>
    <!-- DIALOG -->
    <v-dialog v-model="dialog" max-width="640" persistent>
      <v-card>
        <div class="dlg-head">
          <div class="dlg-head-icon">
            <v-icon color="#fff">{{ oper === 'Add' ? 'mdi-account-arrow-right' : 'mdi-account-edit' }}</v-icon>
          </div>
          <div>
            <div class="dlg-title">{{ oper === 'Add' ? 'New Assignment' : 'Edit Assignment' }}</div>
            <div class="dlg-sub">Assign a child to a care giver</div>
          </div>
          <v-spacer />
          <v-btn icon small class="dlg-close" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="pt-5">
          <v-form>
            <input type="hidden" v-model="assign.idga" />

            <div class="form-section">Assignment</div>
            <v-row dense>
              <v-col cols="12" md="6">
                <label class="cell-muted d-block mb-1">Select Child</label>
                <Select2
                  v-model="assign.child_id"
                  :options="childoption"
                  id="childid"
                  :settings="{ width: '100%' }"
                  @change="changedLabel4"
                />
              </v-col>
              <v-col cols="12" md="6">
                <label class="cell-muted d-block mb-1">Select Care Giver</label>
                <Select2
                  v-model="assign.mother_id"
                  :options="motheroption"
                  id="motherid"
                  :settings="{ width: '100%' }"
                  @change="changedLabel3"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="assign.status"
                  :items="['Permanant', 'Temporary']"
                  label="Transfer type"
                  outlined
                  dense
                  prepend-inner-icon="mdi-swap-horizontal"
                  required
                />
              </v-col>
            </v-row>

            <div class="form-section">Documents & Notes</div>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-file-input
                  dense
                  outlined
                  show-size
                  prepend-icon="mdi-file-upload-outline"
                  label="Court File"
                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  @change="onFileChange"
                ></v-file-input>
                <input type="hidden" v-model="assign.court_file" />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="assign.description"
                  label="Description"
                  auto-grow
                  rows="3"
                  outlined
                  dense
                  prepend-inner-icon="mdi-text-box-outline"
                  @blur="formatDescription"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="dlg-actions">
          <v-spacer />
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="#0d2d63" dark @click="guardar()">
            <v-icon left small>mdi-content-save-outline</v-icon>
            {{ oper === 'Add' ? 'Save Assignment' : 'Save Changes' }}
          </v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar v-model="snackbar" bottom right color="blue">
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
const API_URL_ASSIGN = process.env.VUE_APP_API_URL;
const IMAGE_BASE_MOTHERS = process.env.VUE_APP_IMAGE_BASE; // If separate image directory
const UPLOAD_URL = process.env.VUE_APP_UPLOAD_URL;
export default {
  data() {
    return {
      search: '',
      dialog: false,
      diag: false,
      oper: 'Add',
      snackbar: false,
      text: '',
      assignments: [],
      assign: {
        idga: '',
        child_id: '',
        mother_id: '',
        court_file: '',
        status: '',
        description: '',
        usr_id: '',
      },
      headers: [
        { text: 'No.', value: 'index' },
        { text: 'Child Name', value: 'childname' },
        { text: 'Care Giver', value: 'mothername' },
        { text: 'Status', value: 'status' },
        { text: 'Description', value: 'description' },
        { text: 'Files', value: 'files', sortable: false },
        { text: 'Show More', value: 'more', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      motheroption:[],
      childoption:[],
      moreinfo: [],
      uploadBaseUrl: IMAGE_BASE_MOTHERS,
    };
  },
  mounted() {
    this.mostrar();
    this.fetchchild();
    this.fetchmother();
  },
  methods: {

onFileChange(value) {
  // Support both native <input type="file"> events and v-file-input values
  let file = null;
  if (value instanceof File) {
    file = value;
  } else if (Array.isArray(value) && value[0] instanceof File) {
    file = value[0];
  } else if (value && value.target && value.target.files && value.target.files[0]) {
    file = value.target.files[0];
  }

  if (!file) return;

  const formData = new FormData();
  formData.append('file', file);

  axios
    .post(UPLOAD_URL, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => {
      // upload.php returns stored filename; save it in the model
      this.assign.court_file = res.data;
      this.snackbar = true;
      this.text = 'Court file uploaded!';
      setTimeout(() => (this.snackbar = false), 2000);
    })
    .catch((error) => {
      console.error('Error uploading court file:', error);
      this.snackbar = true;
      this.text = 'Failed to upload court file.';
      setTimeout(() => (this.snackbar = false), 2000);
    });
},

    // getChildImage(name) {
    //   if (!name) return null;
    //   return `${this.uploadBaseUrl}${name}`;
    // },
   // Insert a newline after every N words to keep long descriptions readable
   insertBreaks(text, wordsPerLine = 10) {
     if (!text) return '';
     const words = String(text).trim().split(/\s+/);
     let out = [];
     for (let i = 0; i < words.length; i++) {
       out.push(words[i]);
       if ((i + 1) % wordsPerLine === 0 && i !== words.length - 1) {
         out.push('\n');
       }
     }
     return out.join(' ');
   },
   // Format description field on blur in the form
   formatDescription() {
     this.assign.description = this.insertBreaks(this.assign.description, 10);
   },
   // Normalize descriptions fetched from the API
   normalizeDescription(text) {
     if (!text) return '';
     if (/\n/.test(text)) return text; // already has breaks
     return this.insertBreaks(text, 10);
   },
   // Build absolute URL for stored files
   fileUrl(name) {
     if (!name) return '#';
     const s = String(name);
     if (/^https?:\/\//i.test(s)) return s;
     return this.uploadBaseUrl + s.replace(/^\/+/, '');
   },
   // Get display file name
   basename(name) {
     if (!name) return '';
     return String(name).split('/').pop();
   },
   print(id) {
     this.$htmlToPaper(`printMe-${id}`);
   },
   changedLabel3(event) {
      this.assign.mother_id = event;
   },
    changedLabel4(event) {
      this.assign.child_id = event;
    },
    fetchmother: function(){
      axios.post(API_URL_ASSIGN,{opcion:4, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
      .then(response =>{
        this.motheroption = response.data; 
      //  console.log(this.motheroption)
      });
    },
    fetchchild: function(){
      axios.post(API_URL_ASSIGN,{opcion:5, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
      .then(response =>{
        this.childoption = response.data; 
      });
    },
    formNuevo() {
      this.dialog = true;
      this.oper = 'Add';
      this.assign = {
        idga: '',
        child_id: '',
        mother_id: '',
        court_file: '',
        status: '',
        description: '',
        usr_id: '',
      };
    },
    show(id) {
      axios.post(API_URL_ASSIGN, {opcion: 13, op: 23, idga: id, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.moreinfo = res.data;
        this.diag = true;
        console.log(this.moreinfo)
      });
    },
    formEditar(item) {
      this.dialog = true;
      this.oper = 'Update';
      this.assign = { ...item };
    },
    guardar() {
      this.oper === 'Add' ? this.crear() : this.editar();
      this.dialog = false;
    },
    crear() {
      const payload = {
        idga: this.assign.idga,
        child_id: this.assign.child_id,
        mother_id: this.assign.mother_id,
        court_file: this.assign.court_file,
        status: this.assign.status,
        desc: this.insertBreaks(this.assign.description, 10),
        user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
        op: 1,
        opcion:13
      };
      console.log(payload)
      axios.post(API_URL_ASSIGN, payload).then((res) => {
        this.mostrar();
        this.text = 'Assignment added';
        this.snackbar = true;
      });
    },
    editar() {
      const payload = {
        idga: this.assign.idga,
        child_id: this.assign.child_id,
        mother_id: this.assign.mother_id,
        court_file: this.assign.court_file,
        status: this.assign.status,
        desc: this.insertBreaks(this.assign.description, 10),
        user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
        op: 11,
        opcion:13
      };
      console.log(payload.ministry_file)
      axios.post(API_URL_ASSIGN, payload).then((res) => {
        this.mostrar();
        this.text = 'Assignment updated';
        this.snackbar = true;
      });
    },
    borrar(id) {
      axios.post(API_URL_ASSIGN, { opcion:13, idga: id, op: 12, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.mostrar();
        this.text = 'Assignment deleted';
        this.snackbar = true;
      });
    },
    mostrar() {
      axios.post(API_URL_ASSIGN, { opcion:13, op: 0, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.assignments = (res.data || []).map(it => ({
          ...it,
          description: this.normalizeDescription(it.description)
        }));
        console.log(this.assignments)
      });
    },
  },
};
</script>

<style scoped>
tbody td,
tbody th {
  border-left: 1px solid silver;
}

/* Make the data table more readable and avoid horizontal scrolling */
.assign-table .v-data-table__wrapper {
  overflow-x: hidden; /* prevent horizontal scrollbar */
}

.assign-table table {
  table-layout: fixed; /* distribute columns evenly and allow wrapping */
  width: 100%;
}

.assign-table th,
.assign-table td {
  white-space: normal !important; /* allow wrapping */
  word-break: break-word; /* break long words/strings */
  vertical-align: top;
}

/* Give description column a bit more room (5th column) */
.assign-table tbody td:nth-child(5),
.assign-table thead th:nth-child(5) {
  width: 35%;
}

/* Utility classes for wrapped and clamped text */
.wrap {
  white-space: normal;
}

.line-clamp-2 {
  display: -webkit-box;
  line-clamp: 2; /* standard property for compatibility */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Respect line breaks in text and allow breaking anywhere for long tokens */
.pre-line { white-space: pre-line; }
.break-anywhere { overflow-wrap: anywhere; word-break: break-word; }

/* Subtle zebra striping for better readability */
.assign-table tbody tr:nth-child(odd) {
  background-color: #fafafa;
}

/* Responsive: hide Description column on very small screens */
@media (max-width: 600px) {
  .assign-table thead th:nth-child(5),
  .assign-table tbody td:nth-child(5) {
    display: none;
  }
}
</style>
